<template>
  <jc-dialog ref="createDialog" :show.sync="show"
             btn-confirm-text='<i class="fas fa-save"></i> Lưu'

             title="Thêm mới"
             type="green"
             @onConfirm="$refs.form.submit()"
  >
    <c-form ref="form" @submit="submit()">
      <c-input v-model.trim="model.key"
               form-group-class="col-md-6 col-sm-6"
               label="Key"
               validate-rules="required"/>
      <c-input v-model.trim="model.value"
               form-group-class="col-md-6 col-sm-6"
               label="Value"
               validate-rules="required"/>
      <c-input v-model.trim="model.type" form-group-class="col-md-6 col-sm-6" label="Type" validate-rules="required"/>
      <c-select2 v-model="model.isActive"
                 label="Đang hoạt động"
                 form-group-class="col-md-6 col-sm-6"
                 validate-rules="required"
      >
        <option value="true">true</option>
        <option value="false">false</option>
      </c-select2>
      <c-input v-model.trim="model.description" form-group-class="col-md-12 col-sm-12" label="Description" validate-rules="required"/>

    </c-form>
  </jc-dialog>
</template>

<script>
import dialogMixins from "@/mixins/dialogMixins";

export default {
  name: "add",
  mixins: [
    dialogMixins,
  ],
  data: function () {
    return {
      model: {
        key: null,
        value: null,
        type: null,
        description: null,
        isActive: null
      },
      springProperties: null
    }
  },
  methods: {
    open(item) {
      this.show = true;
      if(item){
        this.model.key = item.key;
        this.model.value = item.value;
        this.model.type = item.type;
        this.model.description = item.description;
        this.model.isActive = item.isActive;
      }
      this.springProperties = null;
    },
    submit: function () {
      this.$showLoader();
      let data = {
        "key": this.model.key,
        "type": this.model.type,
        "value": this.model.value,
        "status": this.model.isActive === "true" ? 1 : 0,
        "description": this.model.description,
      }
      this.$adminService
      .post("/v1.0/config/system-config", data)
      .then(successRes => {
        // this.model.key = null;
        // this.model.value = null;
        // this.model.type = null;
        // this.model.description = null;
        this.$refs.createDialog.close();
        this.$success();
        this.$stopLoader();

        this.$emit("success", successRes);
      }, errorRes => {
        this.$stopLoader();
        this.errorNotify(errorRes)
        .then(errorRes => this.$cmsBadRequest(errorRes));
        this.$emit("error", errorRes);
      })
      ;
    }
  },
  watch: {
    "springProperties": function (value) {
      let v = value.split("=");
      this.model.key = v[0]?.trim();
      this.model.value = v[1]?.trim();
    }
  }
}
</script>

<style scoped>

</style>